<template>
  <div class="Aug2022 text-NotoSansLight">
    <div class="relative hidden lg:block z-10"><img src="~@/assets/images/202208/P1/main-01-17-logo.png" class="object-contain absolute top-0"></div>
    <section class="banner bg-white z-0">
      <div class="container relative hidden lg:flex">
        <div class="z-10 absolute w-24 xl:w-32 quote-left"><img src="~@/assets/images/202208/P1/main-01-02.png" class="object-contain"></div>
        <div class="z-0 px-16 xl:px-10 w-full"><img src="~@/assets/images/202208/P1/main-01-16-banner.png" class="object-contain"></div>
        <div class="z-10 absolute w-24 xl:w-32 quote-right"><img src="~@/assets/images/202208/P1/main-01-01.png" class="object-contain"></div>
      </div>
      <div class="flex relative lg:hidden">
        <div class="lg:px-10 w-full"><img src="~@/assets/images/202208/P1/main-m-banner.png" class="object-contain"></div>
      </div>
    </section>
    <!-- 訂單滿2000送購物金 -->
    <section class="aug-blue-dark z-10">
      <div class="container px-2 pt-2 md:pt-0 md:px-4 relative">
        <div class="lg:-mt-4 z-10">
          <img src="~@/assets/images/202208/P1/main-01-07.png" class="object-contain mx-auto z-10">
        </div>
        <div class="flex flex-wrap">
          <div class="w-1/3 p-3" data-aos-delay="100" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202208/P1/main-01-08.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <div class="w-1/3 p-3" data-aos-delay="200" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202208/P1/main-01-09.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
          <div class="w-1/3 p-3" data-aos-delay="300" data-aos="flip-left" data-aos-once="true"><img src="~@/assets/images/202208/P1/main-01-10.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
        </div>
      </div>
    </section>
    <!-- 滿額好禮大方送 -->
    <section class="mb-6 md:mb-20">
      <div class="container">
        <div class="Full-gift px-2">
          <img src="~@/assets/images/202208/P1/main-01-11.png" class="object-contain mx-auto">
        </div>
        <div class="flex flex-wrap px-3">
          <div class="w-full">
            <img src="~@/assets/images/202208/P1/main-01-12.png" class="object-contain mx-auto">
          </div>

        </div>
        <div class="flex flex-wrap lg:px-24">

          <div class="w-1/5 px-4 lg:-mt-10 hidden md:block">
            <img src="~@/assets/images/202208/P1/main-01-13.png" class="object-contain mx-auto">
          </div>
          <div class="w-full md:w-4/5 px-6 flex items-center mt-3 md:mt-1">
            <p class="text-lg font-medium leading-relaxed">2022.8.22~2022.9.30於LiveABC官方網站及紙本雜誌訂購單購買商品，訂單成立後（需付款完成）可參加「滿額送三大超商100元購物金（3選1）」活動，單筆訂單以一次為限，「三大超商100元購物金（3選1）」為LiveABC向Ticket Xpress即享券企業禮贈平台購買之票券，使用說明請參考：https://reurl.cc/D39Odj。將於2022.10.20前統一以簡訊方式寄出。</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 點讀組合書隨你選 -->
    <section class="aug-blue-light">
      <div class="container">
        <div class="flex flex-wrap px-2 pt-4 lg:py-0 md:px-16">
          <div class="w-1/2 flex px-2 lg:px-4 lg:-mt-16">
            <div><img src="~@/assets/images/202208/P2/main-02-01.png" class="object-contain"></div>
            <div><img src="~@/assets/images/202208/P2/main-02-02.png" class="object-contain"></div>
          </div>
          <div class="w-1/2 px-3">
            <div><img src="~@/assets/images/202208/P2/main-02-03.png" class="object-contain"></div>
            <div class="mb-3"><img src="~@/assets/images/202208/P2/main-02-04-M1.png" class="object-contain"></div>
            <div class="mb-3"><img src="~@/assets/images/202208/P2/main-02-05-M2.png" class="object-contain"></div>
            <div><img src="~@/assets/images/202208/P2/main-02-06-M3.png" class="object-contain"></div>
          </div>
        </div>
        <a href="https://store.liveabc.com/products/magazine/sale?tag=166" target="_blank">
          <img src="~@/assets/images/202208/P2/main-02-07-more.png" class="object-contain">
        </a>
        <div class="mt-3">
          <img src="~@/assets/images/202208/P2/banner-linepen.png" class="object-contain">
        </div>
      </div>
    </section>
    <section class="section py-4 aug-blue-light" v-for="(item, index) in sectionData" :key="index" :id="'section' + index">
      <div class="flex flex-wrap mb-6 container">
        <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 md:w-1/3 lg:w-1/4 p-1 sm:p-3 cursor-pointer" v-for="(child, idx) in item.items" :key="idx">

          <div class="item-inner bg-white rounded-xl p-3 sm:p-4 h-full flex flex-col justify-between hover:shadow-xl shadow-gray-900" v-if="renderComponent">
            <div>
              <div class="outer">
                <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full" style="background-color: #E8E8E8">
                  <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                  <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                </div>
              </div>
              <div class="title p-1 rounded-lg lg:rounded-full mb-3 px-3">
                <div class="w-full border-b-4 border-dotted my-2 border-blue-light"></div>
                <h6 class="text-center text-lg text-aug-blue">{{ child.introduction }}</h6>
              </div>
              <div class="px-3">
                <p v-if="child.name" class="text-center whitespace-pre-wrap text-lg">{{ child.name }}</p>
              </div>
            </div>
            <div class="flex flex-col md:flex-row md:justify-center md:items-end mt-3 flex-wrap mb-2" v-if="child.name">
              <p class="fixed_price text-lg">原價<span class="text-aug-orange text-lg font-semibold">{{ child.fixed_price }}</span>元</p>
            </div>
          </div>
        </router-link>
      </div>
    </section>
    <!-- 雜誌大降價持續熱賣中 -->
    <section class="bg-gray-100 py-6 md:py-12 px-2">
      <div class="container">
        <div class="flex px-6 md:px-16 mb-4">
          <div><img src="~@/assets/images/202208/P3/main-03-01.png" class="object-contain"></div>
          <div><img src="~@/assets/images/202208/P3/main-03-02.png" class="object-contain"></div>
        </div>
        <div class="mb-4">
          <img src="~@/assets/images/202208/P3/main-03-03-pg.png" class="object-contain">
        </div>
        <div class="px-4 md:px-10 lg:px-16">
          <div>
            <img src="~@/assets/images/202208/P3/main-03-04.png" class="object-contain">
          </div>
          <p class="text-lg tracking-wide leading-relaxed px-6 md:px-16 font-medium">2022.7.1~2022.9.30於LiveABC官方網站及紙本雜誌訂購單，完成「2022暑期降價」雜誌訂閱方案，訂單成立後即可參加「訂就抽現金8,888元」活動，１筆訂單可參與抽獎乙次（以訂單編號為主）。</p>
        </div>
      </div>
    </section>
    <section class="magDatas bg-gray-100 px-2">
      <div class="flex container flex-wrap justify-center">
        <div class="flex flex-wrap w-full">
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 md:w-1/4 p-2 md:p-3 cursor-pointer" v-for="(item, index) in magazineData" :key="index">

            <div class="item-inner bg-white rounded-xl p-2 sm:p-4 h-full flex flex-col justify-between" v-if="renderComponent">
              <div class="">
                <div class="outer">
                  <div class="inner mx-auto border-0 absolute w-full h-full p-2 sm:p-3 md:p-4" style="background-color: #E8E8E8">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                    <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
              </div>
              <div class="p-1 rounded-lg xl:rounded-full my-2 lg:my-4 font-bold">
                <div class="w-full border-b-4 border-dotted my-2 border-blue-light"></div>
                <h6 class="text-center text-lg xl:text-2xl text-aug-blue">{{ item.showTitle }}</h6>
                <h6 class="text-center text-base md:text-lg mb-1">{{ item.introduction }}</h6>
                <h6 class="text-center text-base md:text-lg mb-1">{{ item.text }}</h6>
              </div>
              <div class="flex justify-center slogan">
                <a href=""><img src="~@/assets/images/202208/P3/main-03-08-sub.png" class="object-contain mx-auto"></a>
              </div>
            </div>
          </router-link>
        </div>
        <div class="w-full mt-3">
          <img src="~@/assets/images/202208/P3/main-03-05-10books.png" class="object-contain mx-auto">
        </div>
      </div>
    </section>
    <!-- 訂就送經典10本好書 -->
    <section class="digital py-4 md:py-6 px-2 bg-gray-100">
      <div class="bookList bookList3 bg-white relative container rounded-lg">
        <div class="flex flex-wrap" style="background-color: #DBDBDB;">
          <div v-for="(item, index) in sectionData2" :key="index" id="section5" style="background-color: #DBDBDB;" class="w-full">
            <div class="flex flex-wrap" style="background-color: #DBDBDB;">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 lg:w-1/5 cursor-pointer border-dotted border-white"
                :class="{ 'border-b-4': (idx === 0 || idx === 1 || idx === 2 || idx === 3 || idx === 4 || idx === 5), 'lg:border-b-4': (idx === 0 || idx === 1 || idx === 2 || idx === 3)}" v-for="(child, idx) in item.items" :key="idx">
                  <div class="p-3 lg:p-5 border-dotted border-white item-inner h-full flex flex-col justify-between" v-if="renderComponent"
                    :class="{ 'border-r-4': (idx === 0 || idx === 2 || idx === 4 || idx === 6), 'lg:border-r-0': (idx === 4), 'lg:border-r-4': (idx === 0 || idx === 1 || idx === 2 || idx === 3 || idx === 5 || idx === 6 || idx === 7 || idx === 8), 'lg:border-b-0': (idx === 4 || idx === 5)}">
                    <div>
                      <div class="outer mb-2">
                        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full" style="background-color: #E8E8E8">
                          <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                          <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        </div>
                      </div>
                      <div>
                        <p v-if="child.name" class="text-center whitespace-pre-wrap text-lg">{{ child.name }}</p>
                      </div>
                    </div>
                  </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 日本語/HIW -->
    <section class="digital py-4 md:py-6 px-2 bg-gray-100" v-for="(item, index) in sectionData3" :key="index">
      <div class="border-t-2 max-w-6xl mx-auto mb-6 border-blue-dark"></div>
      <div class="flex items-center max-w-5xl mx-auto bg-white p-2 mb-6">
        <div class="w-1/2 md:w-1/3 p-2 md:p-3">
          <div class="outer mb-2">
            <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full" style="background-color: #E8E8E8">
              <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover_img_url">
              <img :src="item.cover_img_url" class="w-full h-full object-contain block" v-else>
            </div>
          </div>
        </div>
        <div class="w-1/2 md:w-1/3 p-2 md:p-3 md:border-r-4 border-dotted text-aug-blue">
          <div>
            <img :src="item.img_url" class="object-contain">
          </div>
          <a :href="item.cover_url" target="_blank" class="md:hidden">
            <img src="~@/assets/images/202208/P3/main-03-08-sub.png" class="object-contain">
          </a>
        </div>
        <a :href="item.cover_url" target="_blank" class="w-1/3 p-4 hidden md:block cursor-pointer">
          <img src="~@/assets/images/202208/P3/main-03-08-sub.png" class="object-contain">
        </a>
      </div>
      <div class="bookList bookList3 bg-white relative max-w-6xl mx-auto rounded-lg">
        <div class="flex flex-wrap" style="background-color: #DBDBDB;">

          <div style="background-color: #DBDBDB;" class="w-full">
            <div class="flex flex-wrap" style="background-color: #DBDBDB;">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 lg:w-1/4 cursor-pointer border-white border"
                v-for="(child, idx) in item.items" :key="idx">

                  <div class="p-3 lg:p-5 border-dotted border-white item-inner h-full flex flex-col justify-between" v-if="renderComponent">
                    <div>
                      <div class="outer mb-2">
                        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full" style="background-color: #E8E8E8">
                          <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                          <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        </div>
                      </div>
                      <div>
                        <p v-if="child.name" class="text-center whitespace-pre-wrap text-lg">{{ child.name }}</p>
                      </div>
                    </div>
                  </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 注意事項 -->
    <section class="note flex w-full py-8 px-2 bg-gray-100">
      <div class="py-3 text-lg container mx-auto w-full font-medium flex flex-wrap">
        <div class="w-full">
          <img src="~@/assets/images/202208/P3/main-03-10-AT.png" class="object-contain mx-auto">
        </div>
        <div class="w-1/4 px-4 lg:-mt-12 hidden md:block">
          <img src="~@/assets/images/202208/P1/main-01-13.png" class="object-contain mx-auto">
        </div>
        <div class="w-full md:w-3/4 px-6 flex items-center mt-3 md:mt-0">
          <ul class="list-decimal list-outside leading-relaxed">
            <li>活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格，不予另行通知。</li>
            <li>「訂就抽現金8,888元」將於2022.10.20抽出乙名得主，公告於LiveABC官方網站及官方臉書粉絲團。</li>
            <li>中華民國稅法規定，中獎贈品或獎金價值超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。</li>
            <li>本活動之抽獎贈品不得轉換、轉讓他人。</li>
            <li>如提供獎項因故無法取得，本公司保留替換其他等值獎項及變更、修改本活動之權利，並將最新變更後內容公布於官網活動頁面，不再個別提醒/通知客戶本活動內容之變更。</li>
            <li>詳細活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 開學必備叢書 -->
    <section class="banner z-0 aug-blue-third">
      <div class="container flex bg pt-4 md:pt-8 px-4 md:px-6 lg:px-12">
        <div class="lg:px-8 lg:py-8 w-2/12"><img src="~@/assets/images/202208/P4/main-04-01.png" class="object-contain"></div>
        <div class="lg:px-6 lg:pt-12 w-6/12 flex items-end"><img src="~@/assets/images/202208/P4/main-04-02.png" class="object-contain"></div>
        <div class="lg:px-6 lg:pt-12 w-4/12 flex items-center"><img src="~@/assets/images/202208/P4/main-04-03.png" class="object-contain"></div>
      </div>
      <div class="container">
        <a href="https://store.liveabc.com/products/book/sale?tag=173" target="_blank">
          <img src="~@/assets/images/202208/P4/main-04-04-more.png" class="object-contain">
        </a>
      </div>
    </section>
    <section class="section py-4 aug-blue-third" v-for="(item, index) in sectionData4" :key="index">
      <div class="flex flex-wrap mb-6 container">
        <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 md:w-1/3 lg:w-1/4 p-3 cursor-pointer" v-for="(child, index) in item.items" :key="index">

          <div class="item-inner bg-white rounded-xl p-3 sm:p-4 h-full flex flex-col justify-between hover:shadow-xl shadow-gray-900" v-if="renderComponent">
            <div>
              <div class="outer">
                <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full" style="background-color: #E8E8E8">
                  <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                  <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                </div>
              </div>
              <div class="title p-1 rounded-lg lg:rounded-full mb-3 px-3">
                <div class="w-full border-b-4 border-dotted my-2 border-blue-light"></div>
                <h6 class="text-center text-lg">{{ child.introduction }}</h6>
              </div>
              <div class="px-3">
                <p v-if="child.name" class="text-center whitespace-pre-wrap text-lg">{{ child.name }}</p>
              </div>
            </div>
            <div class="flex flex-col md:flex-row md:justify-center md:items-end mt-3 flex-wrap mb-2" v-if="child.name">
              <p class="fixed_price text-lg">原價<span class="text-aug-orange text-lg font-semibold">{{ child.fixed_price }}</span>元</p>
            </div>
          </div>
        </router-link>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios'
import jump from 'jump.js'
export default {
  name: 'Aug2022',
  metaInfo () {
    return {
      title: '滿額送超商購物金｜LiveABC開學書展，現正開跑中！',
      titleTemplate: null
    }
  },
  components: {
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: false,
      renderComponent: true,
      // 當月雜誌
      magazineData: null,

      sectionData: [
        {
          img_url: require('@/assets/images/202204/tt-2.png'),
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7456, introduction: '多益TOEIC最強三大觀念起手式！ ' },
            { id: 7399, introduction: '系統化串聯相關字彙' },
            { id: 7873, introduction: '幫助您高效背誦單字' },
            { id: 7694, introduction: '讓佩佩豬當你的英語小老師' },
            { id: 7731, introduction: '溫暖童趣的彩圖，歡樂的親子共讀時光' },
            { id: 6869, introduction: '快速掌握雅思高分技巧' },
            { id: 6356, introduction: '出發日本前必備精彩主題' },
            { id: 6051, introduction: '獨家歸納聯想學習法，輕鬆記單字' }
          ]
        }
      ],
      sectionData2: [
        {
          img_url: require('@/assets/images/202204/tt-2.png'),
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 1771, introduction: '學英語也能輕鬆又有趣' },
            { id: 6238, introduction: '學英語也能輕鬆又有趣' },
            { id: 5543, introduction: '學英語也能輕鬆又有趣' },
            { id: 7434, introduction: '學英語也能輕鬆又有趣' },
            { id: 6521, introduction: '學英語也能輕鬆又有趣' },
            { id: 4423, introduction: '認識26個字母大小寫' },
            { id: 4418, introduction: '教你看圖就能學好單字' },
            { id: 7002, introduction: '教你看圖就能學好單字' },
            { id: 7161, introduction: '教你看圖就能學好單字' },
            { id: 5450, introduction: '教你看圖就能學好單字' }
          ]
        }
      ],
      sectionData3: [
        {
          img_url: require('@/assets/images/202208/P3/main-03-07-JP.png'),
          cover_img_url: 'https://s3.ap-northeast-1.amazonaws.com/storage.liveabc.com/cover/HFAuiS5GHjHv9JrFAUaIShqOXhrTDrZ9qoDlWAq7.jpeg',
          cover_url: 'https://store.liveabc.com/magazine/detail/7577',
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7403, introduction: '學英語也能輕鬆又有趣' },
            { id: 5078, introduction: '學英語也能輕鬆又有趣' },
            { id: 5094, introduction: '學英語也能輕鬆又有趣' },
            { id: 5372, introduction: '學英語也能輕鬆又有趣' },
            { id: 5504, introduction: '學英語也能輕鬆又有趣' },
            { id: 5934, introduction: '認識26個字母大小寫' },
            { id: 6237, introduction: '教你看圖就能學好單字' },
            { id: 6263, introduction: '教你看圖就能學好單字' },
            { id: 6874, introduction: '教你看圖就能學好單字' },
            { id: 7732, introduction: '教你看圖就能學好單字' }
          ]
        },
        {
          img_url: require('@/assets/images/202208/P3/main-03-09-HIW.png'),
          cover_img_url: 'https://s3.ap-northeast-1.amazonaws.com/storage.liveabc.com/cover/iTVbNZKh9NTqF8CVLqqQmuvFdbmM2EAju1ut6T41.jpeg',
          cover_url: 'https://store.liveabc.com/magazine/detail/7586',
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7963, introduction: '學英語也能輕鬆又有趣' },
            { id: 7134, introduction: '學英語也能輕鬆又有趣' },
            { id: 5967, introduction: '學英語也能輕鬆又有趣' },
            { id: 5977, introduction: '學英語也能輕鬆又有趣' },
            { id: 6189, introduction: '學英語也能輕鬆又有趣' },
            { id: 6007, introduction: '認識26個字母大小寫' },
            { id: 7582, introduction: '教你看圖就能學好單字' }
          ]
        }
      ],
      sectionData4: [
        {
          img_url: require('@/assets/images/202204/tt-2.png'),
          // item_img_url: require('@/assets/images/202202/01-pic.png'),
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7700, introduction: '英文作文學霸養成' },
            { id: 7687, introduction: '掌握命題趨勢與6大得分關鍵' },
            { id: 5930, introduction: '大量累積英文閱讀實力' },
            { id: 7848, introduction: '專為準備大學考試的你深量身打造' },
            { id: 7549, introduction: '背單字變得輕鬆又有趣' },
            { id: 7849, introduction: 'CNN新聞出現的單字，原來是這樣用的' },
            { id: 7955, introduction: '迅速提升多益成績增進職場競爭力' },
            { id: 7648, introduction: '最符合108課綱的小學生英語教材' }
          ]
        }
      ]
    }
  },
  async mounted () {
    await this.getEvent()
    this.getMag()
  },
  destroyed () {
  },
  methods: {
    async getEvent () {
      let self = this
      for (let i = 0; i < self.sectionData.length; i++) {
        await self.getData(i, self.sectionData[i].items)
      }
      for (let i = 0; i < self.sectionData2.length; i++) {
        await self.getData(i, self.sectionData2[i].items)
      }
      for (let i = 0; i < self.sectionData3.length; i++) {
        await self.getData(i, self.sectionData3[i].items)
      }
      for (let i = 0; i < self.sectionData4.length; i++) {
        await self.getData(i, self.sectionData4[i].items)
      }
      // self.getData2(self.magData)
    },

    getData (idx, itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }

      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },

    getData2 (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },

    getMag () {
      let self = this
      let arr = [
        { id: 7600, category_id: 123, showTitle: 'ABC互動英語', introduction: '初級 | 基礎 | 活用', text: '打好英語基礎的最佳選擇！', url: 'https://store.liveabc.com/magazine/detail/7555' },
        { id: 7616, category_id: 124, showTitle: 'Live互動英語', introduction: '中級 | 生活 | 實用', text: '日常生活實用英語輕鬆學！', url: 'https://store.liveabc.com/magazine/detail/7556' },
        { id: 7608, category_id: 125, showTitle: 'ALL+互動英語', introduction: '中高級 | 進階 | 應用', text: '閱讀寫作訓練豐富又多元！', url: 'https://store.liveabc.com/magazine/detail/7557' },
        { id: 7592, category_id: 126, showTitle: 'CNN互動英語', introduction: '新聞 | 時事 | 新知', text: '官方授權的專業新聞素材！', url: 'https://store.liveabc.com/magazine/detail/7558' }
        // { category_id: 123, showTitle: 'ABC互動英語', introduction: '初級 | 基礎 | 活用', text: '打好英語基礎的最佳選擇！', url: 'https://store.liveabc.com/magazine/detail/7555' },
        // { category_id: 124, showTitle: 'Live互動英語', introduction: '中級 | 生活 | 實用', text: '日常生活實用英語輕鬆學！', url: 'https://store.liveabc.com/magazine/detail/7556' },
        // { category_id: 125, showTitle: 'ALL+互動英語', introduction: '中高級 | 進階 | 應用', text: '閱讀寫作訓練豐富又多元！', url: 'https://store.liveabc.com/magazine/detail/7557' },
        // { category_id: 126, showTitle: 'CNN互動英語', introduction: '新聞 | 時事 | 新知', text: '官方授權的專業新聞素材！', url: 'https://store.liveabc.com/magazine/detail/7558' }
      ]
      axios.get('/newest-magazines/')
        .then((response) => {
          response.data.map(item1 => {
            arr.map(item2 => {
              if (item1.category_id === item2.category_id) {
                return Object.assign(item1, item2)
              }
            })
          })

          self.magazineData = this.filterMag(response.data)
        })
    },
    filterMag (ar) {
      let categoryAr = [123, 124, 125, 126]
      return ar.filter((item) => {
        return categoryAr.indexOf(item.category_id) > -1
      })
    },

    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },

    toTop (n) {
      jump(`#section${n}`, {
        duration: 500,
        offset: 0
      })
    },

    toTopWeb () {
      jump(`.Aug2022`, {
        duration: 600,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.rounded-xl {
  border-radius: 1.5rem;
}
.pricing {
  color: #ff0000;
}
.border-blue {
  border-color: #26456A;
}
.border-blue-light {
  border-color: #7DAFd2;
}
.aug-blue-dark {
  background: #053A70;
}
.border-blue-dark {
  border-color: #053A70;
}
.aug-blue-medium {
  background: #C6DCE9;
}
.aug-blue-third {
  background: #7DAFd2;
}
.aug-blue-light {
  background: #C6DCE9;
}
.text-aug-orange {
  color: #ff8e50;
}
.text-aug-blue {
  color: #7DAFd2;
}
.Full-gift {
  background-image: url('~@/assets/images/202208/P1/main-01-11-bg.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.dotted {
  border-color: #26456A;
  &:before {
    content: "";
    position: absolute;
    width: 8px;
    height: 8px;
    background: #26456A;
    border-radius: 50%;
    top: -5px;
    left: 0;
  }
  &:after {
    content: "";
    position: absolute;
    width: 8px;
    height: 8px;
    background: #26456A;
    border-radius: 50%;
    top: -5px;
    right: 0;
  }
}
.outer {
  position: relative;
  width: 100%;
  background:white;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.title {
  color: #7DAFd2;
}
.fixed_price {
  text-decoration-color: red;
}
.Aug2022 {
  .banner {
    .bg {
      background-image: url('~@/assets/images/202208/P4/main-04-05-bg.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
    .quote-left {
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .quote-right {
      right: -2%;
      top: 60%;
      @media (max-width: 1440px) {
        right: 0%;
      }
    }
  }
  .main {
    .openMenu {
      top: 25%;
    }
    .fixed-btn {
      top: 50%;
      transform: translateY(-50%);
      right: -100%;
      transition: 0.3s;
    }
    .fixed-btn-open {
      right: 5%;
    }
    .bg-yellow {
      background-color: #D7F01B;
    }
    .more {
      .on {
        display: none;
      }
      &:hover {
        .off {
          display: none;
        }
        .on {
          display: block;
        }
      }
    }
    .item-card {
      min-height: 360px;
    }
    .item {
      .item-inner {
        min-height: 360px;
        transition: .3s;
        &:hover {
          transform: translateY(-15px);
        }
      }
    }
    .hover-item {
      .on {
        display: none;
      }
      &:hover {
        .off {
          display: none;
        }
        .on {
          display: block;
        }
      }
    }
    .section6 {
      color: #26456A;
    }
  }
}
</style>
